<template>
  <ArtisanGrid
    ref="SysMenuInfo"
    metaKey="SysMenuInfo"
    :leftOption="option"
    :confirmAfter="loadTreeData"
    :delRowAfter="loadTreeData"
  >
    <template #icon="{ row }">
      <i :class="row.icon"></i>
    </template>
  </ArtisanGrid>
</template>

<script>
export default {
  data() {
    return {
      option: {
        width: "20%",
        title: "菜单",
        treeKey: "CusMenuOption",
        searchField: "parentId",
      },
    };
  },
  methods: {
    loadTreeData() {
      this.$refs.SysMenuInfo.reloadDicByCol("parentId");
    },
  },
};
</script>

<style>
</style>